import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PaginationBar({ page, pageCount, onPageChange, total }) {
  if (pageCount <= 1) {
    return (
      <p className="text-xs text-muted-foreground" data-testid="pagination-info">
        {total} rader
      </p>
    );
  }
  return (
    <div className="flex items-center justify-between" data-testid="pagination-bar">
      <p className="text-xs text-muted-foreground">
        Sida {page} av {pageCount} · {total} rader
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8"
          disabled={page >= pageCount}
          onClick={() => onPageChange(page + 1)}
          data-testid="pagination-next"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
